import { TUserExpertise } from '../types/users';

/**
 * ROOMS
 */
const MEDICAL_ASSISTANCE_IC_CRISIS =
  'medical_assistane_in_crisis_situations@conference.hilbiprod-test.m.in-app.io';

/**
 * EXPERTISE_IDS
 */
const MEDICAL_INFORMATICS = '101';

/**
 * Based on these rules can restrict users to submit to rooms
 * roomID / allowed expertises to post
 */
const RULES = new Map([[MEDICAL_ASSISTANCE_IC_CRISIS, [MEDICAL_INFORMATICS]]]);

export default function hasDisabledSubmitToRoom(currentRoom: string, expertises: TUserExpertise[]) {
  if (!RULES.has(currentRoom)) {
    return false;
  } else if (expertises.length === 0) {
    return true;
  }

  const canSubmit = RULES.get(currentRoom) as string[];
  for (let i = 0; i < expertises.length; i++) {
    if (canSubmit.includes(expertises[i].expertise)) {
      return false;
    }
  }

  return true;
}
